import { SxySchemaEditorController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Open API schema editor: Used for editing schemas is usecases.
 * @example
 * ```html
 * <sxy-schema-editor model="$ctrl.currentSchema"></sxy-schema-editor>
 * ```
 */
export class SxySchemaEditor extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
      model: "<",
    };

    /** Uses the SxyInputController */
    public controller = SxySchemaEditorController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/sxy-form/SxySchemaEditor.html";
}
